import * as actionTypes from './actionTypes'


export function updateTotalsSectionField(field, payload) {
  return {
    type: actionTypes.UPDATE_TOTALS_SECTION_FIELD,
    payload,
    field
  }
}

export function saveTotalsSectionField(field, payload) {
  return {
    type: actionTypes.SAVE_TOTALS_SECTION_FIELD,
    payload,
    field
  }
}
